import React from "react";
import { useTranslation } from "react-i18next";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { useNavigate, useSearchParams } from "react-router";

import { IconButton, PlateNumberInput } from "../../components";
import { useOverlay, usePlateNumberHistory } from "../../providers";
import client from "../../client";

const HomePage: React.FC = () => {
  const { plateNumberSearchHistory, removePlateNumberFromHistory } = usePlateNumberHistory();
  const { setLoading } = useOverlay();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [plateNumber, setPlateNumber] = React.useState<string>("");

  const getLastCarStateNumByGateQr = React.useCallback((gateQr: string) => {
    if (typeof gateQr !== 'string' || gateQr.trim() === '') return;
    setLoading(true);
    client
      .post("/v1.0/getLastCarStateNumByGateQr", { gateQr })
      .then((response) => {
        console.log(response);
        const carStateNum = response.data['carStateNum'];
        if (carStateNum)
          navigate(`/bill/${carStateNum}`, { replace: true });
      })
      .finally(() => setLoading(false));
  }, []);

  React.useEffect(() => {
    const gateQr = searchParams.get("gateQr");
    console.log(gateQr);
    if (typeof gateQr === 'string' && gateQr.trim().length > 0) {
      getLastCarStateNumByGateQr(gateQr);
    }
  }, [getLastCarStateNumByGateQr]);

  const handlePlateNumberSearch: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    navigate(`/bill/${plateNumber}`);
  };

  return (
    <div className="w-full h-full flex items-center justify-around lg:justify-center flex-col gap-4">
      <div />
      <h1 className="text-[2.5rem] leading-10 font-bold text-center">{t("home.description")}</h1>
      <form className="w-full flex-center gap-2" onSubmit={handlePlateNumberSearch}>
        <PlateNumberInput
          onChanged={(value) => setPlateNumber(value)}
          history={plateNumberSearchHistory}
          onHistoryRemove={(entry) => removePlateNumberFromHistory(entry)}
          onHistorySelect={(entry) => navigate(`/bill/${entry}`)}
        />
        <IconButton type="submit" icon={FaMagnifyingGlass} size="xl" reverseColors />
      </form>
    </div>
  );
};

export default HomePage;
